export default __webpack_public_path__ + "static/media/group59Copy.fa0513ab.svg";